import { createIcon } from "@chakra-ui/react";

const UnHappy = createIcon({
  displayName: "UnHappy",
  viewBox: "24 24 40 40",
  path: (
    <>
      <path d="M43.89 48.15a13.26 13.26 0 0 1 8.94 3.49 1 1 0 0 1-1.31 1.41 11.26 11.26 0 0 0-15.06-.18 1 1 0 1 1-1.27-1.44 13.12 13.12 0 0 1 8.7-3.28z" />
      <circle cx="44" cy="44" r="20" fill="currentColor" />
      <path d="M43.89 48.15a13.26 13.26 0 0 1 8.94 3.49 1 1 0 0 1-1.31 1.41 11.26 11.26 0 0 0-15.06-.18 1 1 0 1 1-1.27-1.44 13.12 13.12 0 0 1 8.7-3.28z" />
      <circle cx="52.22" cy="41" r="2.08" />
      <circle cx="35.78" cy="41" r="2.08" />
    </>
  )
});

export default UnHappy;
